// extracted by mini-css-extract-plugin
export default {"filtersCollapse":"inbox-tab_filtersCollapse__V6Nbd","filters":"inbox-tab_filters__7wpG7","filter":"inbox-tab_filter__2BML1"};